<template>
	<div ref="slide" v-parallax-fit="parallax" class="slide-crown" :style="style">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/02_treeleaves.png" alt=""> 
	</div>
</template>

<script>
	export default {
		data() {
			return {
				start: 0,
				end: 1600,
				style: {maskImage: 'linear-gradient(to top, black 0%, transparent 0%)'},
				parallax: [
					{
						start: 5000,
						end: 5200,
						fromStyle: { opacity: 1 },
          				toStyle: { opacity: 0 },
						easing: 'linear'
					}
				]
			}
		},
		mounted() {
			window.addEventListener('scroll', () => {
				if (window.scrollY >= this.start && window.scrollY <= this.end) {	
				  	let scrollPercent = Math.round((window.scrollY / this.end) * 100);
				  	this.style.maskImage = `linear-gradient(to top, black ${scrollPercent / 2}%, transparent ${scrollPercent}%)`;

				} else if (window.scrollY >= this.start && window.scrollY <= this.end + this.end) {
					this.style.maskImage = `linear-gradient(to top, black 100%, transparent 100%)`;
				}
			});
		}
	}
</script>

<style class="scss" scoped>
	.slide-crown {
		width: 750px;
	    position: absolute;
	    top: -22.5%;
	   	left: 4.5%;
		transform: rotate(-1.9deg);
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
        .slide-crown {
        	width: 650px;
        	top: -19%;
        	left: 5.3%;
        }
    }

    @media screen and (max-width: 1440px) {
    	.slide-crown {
    		width: 600px;
    		top: -22%;
    		left: 2%;
    		transform: rotate(-3deg);
    	}
    }

    @media screen and (max-width: 1280px) {
    	.slide-crown {
    		width: 400px;
		    top: -21%;
		    left: 4%;
    	}
    }

    @media screen and (max-width: 650px) {
    	.slide-crown {
    		width: 200px;
		    top: -22%;
		    left: 5%;
    	}
    }
</style>
